import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Zap, Compass, Palette, TrendingUp } from 'lucide-react';
import { tw } from '../utils/tw';
var FeatureCard = function (_a) {
    var icon = _a.icon, title = _a.title, description = _a.description;
    return (_jsxs("div", { className: "".concat(tw.card, " hover:-translate-y-1 transition-all duration-300"), children: [_jsx("div", { className: "bg-primary-50 dark:bg-primary-900/30 p-3 rounded-lg w-fit mb-4", children: icon }), _jsx("h3", { className: "text-xl font-bold text-slate-800 dark:text-white mb-3", children: title }), _jsx("p", { className: "text-slate-600 dark:text-slate-300", children: description })] }));
};
var Features = function () {
    var features = [
        {
            icon: _jsx(Zap, { size: 24, className: "text-primary-500" }),
            title: "Smart Dopamine Management",
            description: "BoredGenie guides you from passive scrolling to active productivity in smooth, natural steps."
        },
        {
            icon: _jsx(Compass, { size: 24, className: "text-primary-500" }),
            title: "Mood-Based Recommendations",
            description: "Tell us how you're feeling and get personalized content that matches your current state of mind."
        },
        {
            icon: _jsx(Palette, { size: 24, className: "text-primary-500" }),
            title: "Progressive Engagement",
            description: "Start with light, fun content and gradually transition to more meaningful activities."
        },
        {
            icon: _jsx(TrendingUp, { size: 24, className: "text-primary-500" }),
            title: "Gamified Productivity",
            description: "Earn points and unlock rewards as you shift from boredom to focused productivity."
        }
    ];
    return (_jsx("section", { id: "features", className: "".concat(tw.section, " bg-white/40 dark:bg-slate-800/20"), children: _jsxs("div", { className: tw.containerCustom, children: [_jsxs("div", { className: "text-center mb-16", children: [_jsxs("h2", { className: "".concat(tw.headingLg, " mb-4"), children: ["Features That ", _jsx("span", { className: tw.textGradient, children: "Transform Boredom" })] }), _jsx("p", { className: "text-lg text-slate-600 dark:text-slate-300 max-w-3xl mx-auto", children: "BoredGenie turns unproductive scrolling into a meaningful journey toward focus and creativity." })] }), _jsx("div", { className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8", children: features.map(function (feature, index) { return (_jsx(FeatureCard, { icon: feature.icon, title: feature.title, description: feature.description }, index)); }) })] }) }));
};
export default Features;
